export class ApplicationConstants { 

  public static API_BASE_URL = "https://meeranewsagency.cannytechnology.com/api/";
   //public static API_BASE_URL = "https://meeranewsagency.cannytechnology.com/api/";
  // public static API_BASE_URL = "https://distributordemo.herokuapp.com/api/";

  //demo https://meeranewsagency.herokuapp.com/
 // public static API_BASE_URL = "https://meeranewsagency.herokuapp.com/api/";
   
    }